<template>
    <!-- TODO - EPIC-1000 EPIC : Soap migration -->
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item v-if="soapLockedOrPatientInactive" @click="showList()">
                <i class="cus-page-white-text"></i>
                Medical Note
            </b-nav-item>
            <b-nav-item-dropdown no-flip name="tab-items" v-else>
                <template slot="button-content">
                    <i class="cus-page-white-text"></i>
                    Medical Note
                </template>
                <b-dropdown-item @click="showList()">
                    <i class="cus-page-white-stack"></i>
                    View Medical Note
                </b-dropdown-item>

                <template v-if="activeTabIndex === 0">
                    <div class="dropdown-divider"></div>

                    <b-dropdown-item
                        @click.stop="openModal(TABMEDICALNOTE.VIEWS.SNIPPET)"
                    >
                        <i class="cus-add"></i>
                        Add Snippet
                    </b-dropdown-item>
                    <b-dropdown-item
                        v-if="
                            soap.template_id &&
                            ![
                                MEDICALNOTES.SOAP_TYPE.BASIC,
                                MEDICALNOTES.SOAP_TYPE.SIMPLE,
                                MEDICALNOTES.SOAP_TYPE.STANDARD
                            ].includes(soap.type)
                        "
                        @click.stop="openModal(TABMEDICALNOTE.VIEWS.SECTION)"
                    >
                        <i class="cus-add"></i>
                        Add Section
                    </b-dropdown-item>
                </template>
            </b-nav-item-dropdown>
        </template>
        <SoapContentLoading v-if="isSoapContentLoading" />
        <div id="soap-wrapper">
            <div
                v-if="!isSoapContentLoading"
                id="soap-menu"
                :class="{ hidden: !isLeftNavigation }"
            >
                <SoapNavigationMenu
                    :content="soapContent"
                    :isLoadingMenu="isSoapContentLoading"
                    @scroll-to-section="scrollToSection"
                />
            </div>

            <div
                v-if="!isSoapContentLoading"
                id="soap-menu-divider"
                @click="toggleShowSoapNavigation"
            >
                <div
                    v-if="
                        !isSoapContentLoading &&
                        soapContent !== null &&
                        Object.keys(soapContent).length > 0
                    "
                    class="toggler-chevron"
                >
                    <div class="sticky-chevron">
                        <i
                            :class="
                                !isLeftNavigation
                                    ? 'fa fa-chevron-circle-right animate-icon'
                                    : 'fa fa-chevron-circle-right animate-icon rotate-180'
                            "
                            v-b-tooltip.hover.right="{
                                title: !isLeftNavigation ? 'Expand' : 'Collapse'
                            }"
                        />
                    </div>
                </div>
                <div
                    v-if="
                        !isSoapContentLoading &&
                        soapContent !== null &&
                        Object.keys(soapContent).length > 0
                    "
                    class="vertical-line"
                ></div>
            </div>

            <div id="soap-content">
                <b-card-text>
                    <SoapContentDisplay
                        v-if="!isLocked"
                        ref="SoapContentDisplay"
                        :key="keyview"
                        :soapContent="soapContent"
                        :recordList="recordList"
                        :isRecordListLoading="isRecordListLoading"
                        :isSoapContentLoading="isSoapContentLoading"
                        :activeTabIndex="activeTabIndex"
                        @open-modal="openModal"
                        @update-tabs-count="updateTabsCount"
                        @change-tab="changeTab"
                        @reload-record-list="getRecordList(true)"
                        @reload="reloadPage"
                        @reload-tab="showList"
                    />
                    <SoapContentLockedDisplay
                        v-else
                        ref="SoapContentLockedDisplay"
                        :key="keyview"
                        :soapContent="soapContent"
                        :recordList="recordList"
                        :isRecordListLoading="isRecordListLoading"
                        :isSoapContentLoading="isSoapContentLoading"
                        @open-modal="openModal"
                    />
                </b-card-text>
            </div>
        </div>
    </b-tab>
</template>

<script>
import MEDICALNOTES from "@/constants/medical-notes";
import SoapNavigationMenu from "@/components/soap/soap-navigation-menu";
import SoapContentDisplay from "@/components/soap/soap-content";
import SoapContentLockedDisplay from "@/components/soap/soap-content-locked";
import SoapContentLoading from "@/components/soap/soap-content-loading";
import PatientSoapService from "@/services/patient/patient-soap";
import TABMEDICALNOTE from "@/constants/tab-medical-note";
import { sortBy } from "lodash";

const PATIENT_STATUS_INACTIVE = 2;
const SOAP_LOCKED = 1;

export default {
    components: {
        SoapNavigationMenu,
        SoapContentDisplay,
        SoapContentLockedDisplay,
        SoapContentLoading
    },
    props: {
        soap: {
            type: Object,
            required: true
        },
        activeTabIndex: {
            type: Number
        }
    },
    data() {
        return {
            TABMEDICALNOTE,
            keyview: 0,
            soapContent: null,
            recordList: null,
            MEDICALNOTES,
            isRecordListLoading: false,
            isSoapContentLoading: false
        };
    },
    computed: {
        statusInActive() {
            return this.$store.getters["soap/patientStatusInActive"];
        },
        soapLockedOrPatientInactive() {
            // Based on here apps/application/views/staff/patient/soap/sub/navbar.php
            return (
                this.isLocked ||
                this.soap.patient.status === PATIENT_STATUS_INACTIVE
            );
        },
        isLocked() {
            return this.$store.getters["soap/isLocked"];
        },
        isLeftNavigation: {
            get() {
                return this.$store.state?.userPreferences?.prefs?.soap?.left_navigation ?? false; // prettier-ignore
            },
            set(value) {
                return this.$store.commit("userPreferences/setSpecificPref", {
                    type: "soap",
                    data: { left_navigation: value }
                });
            }
        }
    },
    mounted() {},
    methods: {
        async showList() {
            this.isSoapContentLoading = true;
            this.soapContent = null;
            let resSoapStatus = await PatientSoapService.getSoapStatus(
                this.soap.id
            );
            if (
                resSoapStatus?.resource &&
                this.soap.status !== resSoapStatus.resource.status &&
                resSoapStatus.resource.status === SOAP_LOCKED
            ) {
                // The $parent for this component is b-tabs in soap.vue, so to render the method in soap.vue must invoke $parent.$parent
                await this.$parent.$parent.getDetails();
            }

            this.keyview += 1;
            await Promise.all([
                await this.getSoapPref(),
                await this.getRecordList(),
                await this.getSoapContent(this.soap.id)
            ]);

            this.isSoapContentLoading = false;

            this.$nextTick(() => {
                if (!this.isLocked && this.$refs.SoapContentDisplay) {
                    this.$refs.SoapContentDisplay.init(); // Re-connect socket
                }

                // retrieve lastScrollPos x and y from local storage
                let scrollPosition = JSON.parse(
                    sessionStorage.getItem(`${this.soap.id}_lastScrollPos`)
                );

                if (scrollPosition !== null) {
                    // By using scrollTo, the scroll will go the exact position of x and y
                    // while using scrollBy, it will scroll relatively to the current position
                    window.scrollTo({
                        left: scrollPosition.x || 0,
                        top: scrollPosition.y || 0
                    });

                    if (scrollPosition.lastFocusedElementId) {
                        $("#" + scrollPosition.lastFocusedElementId).trigger(
                            "focus"
                        );
                    }

                    sessionStorage.removeItem(`${this.soap.id}_lastScrollPos`);
                }
            });
        },
        async getSoapPref() {
            // re-fetch soap pref to cater case user open multiple tab
            await this.$store.dispatch("userPreferences/initGetPrefs");
        },
        properDataForSpeech(xml) {
            if (Array.isArray(xml)) {
                return xml;
            } else if (typeof xml === "object" && xml !== null) {
                return Object.values(xml);
            } else {
                return [];
            }
        },
        async getSoapContent(soapId) {
            let self = this;
            if (soapId) {
                let res = await PatientSoapService.getSoapXmlContent(soapId);
                if (res.message.code == 200) {
                    self.soapContent = res.resources.xmlData;

                    window.SPEECH_SOAP_CONTENT = this.properDataForSpeech(
                        res.resources.xmlData
                    );

                    this.$store.commit(
                        "soap/setServerTimestampXMLContent",
                        res.resources.server_timestamp
                    );
                    this.$store.commit(
                        "soap/setInitialTimestampXMLContent",
                        Math.floor(self._now().toSeconds())
                    );
                }
            } else {
                this.$router.push({ name: "patient_dashboard" });
            }
        },
        async getRecordList(isReloadSoapDetails = false) {
            let self = this;
            const patientId = self.soap?.patient_id;
            const soapId = self.soap?.id;

            let params = {
                soapId: soapId,
                type: "record",
                soap_plan_section: true
            };

            // Reload the soap details if triggerred from new record/new bundle from soap-content-record-list to show new created invoice/reminders
            if (isReloadSoapDetails) {
                this.reloadPage();
                this.updateTabsCount(["tabRecords", "tabDocuments"]);
            }

            if (patientId) {
                self.recordList = [];
                self.isRecordListLoading = true;
                await PatientSoapService.getSoapRecords(patientId, params)
                    .then(res => {
                        if (res && res.message && res.message.code == 200) {
                            self.recordList = sortBy(res.resources, "index");
                        }
                    })
                    .finally(() => {
                        self.isRecordListLoading = false;
                    });
            }
        },
        filterActive(data) {
            const filteredData = {};

            // recursive data isactive
            Object.keys(data).forEach(key => {
                const obj = data[key];
                if (obj.isactive === "1") {
                    filteredData[key] = obj;
                    if (
                        obj.components &&
                        Object.keys(obj.components).length > 0
                    ) {
                        obj.components = this.filterActive(obj.components);
                    }
                }
            });

            return filteredData;
        },
        openModal(key) {
            this.$emit("open-modal", key);
        },
        updateTabsCount(tabs) {
            this.$emit("update-tabs-count", tabs);
        },
        reloadPage() {
            this.$emit("reload");
        },
        changeTab() {
            this.$emit("change-tab");
        },
        scrollToSection(elementId) {
            if (elementId) {
                if (!this.isLocked) {
                    this.$refs.SoapContentDisplay.scrollToTitleContent(
                        elementId
                    );
                } else {
                    this.$refs.SoapContentLockedDisplay.scrollToTitleContent(
                        elementId
                    );
                }
            }
        },
        disconnectSocket() {
            this.$refs.SoapContentDisplay?.disconnectSocket();
        },
        toggleShowSoapNavigation() {
            let self = this;
            self.isLeftNavigation = !self.isLeftNavigation;
            self.saveSoapNavigationPreferences(self.isLeftNavigation);
        },
        async saveSoapNavigationPreferences(value) {
            await this.$store.dispatch("userPreferences/updatePref", {
                category: "soap",
                data: { left_navigation: value }
            });
        },
        checkSocketIsConnected() {
            return (
                this.$refs.SoapContentDisplay?.checkSocketIsConnected?.() ??
                Promise.resolve(false)
            );
        }
    }
};
</script>
<style scoped>
.animate-icon {
    transition: transform 0.5s ease;
}

.rotate-180 {
    transform: rotate(180deg);
}

@media (max-width: 768px) {
    #soap-wrapper {
        flex-direction: column-reverse;
    }

    #soap-menu {
        order: 2;
        width: 100%;
        height: auto;
        overflow: clip;
        position: relative;
        padding-bottom: 20px;
    }

    #soap-menu-divider {
        display: none;
    }
}

#soap-wrapper {
    display: flex;
    overflow: clip;
}

#soap-menu {
    width: 250px;
    opacity: 1;
    display: block;
    transition: transform 0.2s ease, width 0.2s ease, opacity 0.1s ease;
}

@media (min-width: 769px) {
    #soap-menu.hidden {
        transform: translateX(-100%);
        width: 0;
        opacity: 0;
        overflow: clip;
    }
}

#soap-menu-divider {
    width: 30px;
    display: flex;
    justify-content: center;
    position: relative;
    cursor: pointer;
}

#soap-menu-divider:hover .vertical-line {
    width: 1.5px;
    background-color: #a0a0a0;
}

.toggler-chevron {
    position: absolute;
    display: flex;
    flex-direction: column;
    top: 14px;
    height: 100%;
}

.sticky-chevron {
    position: sticky;
    top: 30px;
    background: white;
    border-radius: 50px;
}

.vertical-line {
    width: 1px;
    background-color: #dddddd;
}

#soap-content {
    flex: 1;
    overflow: auto;
}
</style>
